import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=6989d212&scoped=true&"
import script from "./NumberInput.vue?vue&type=script&lang=ts&"
export * from "./NumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=6989d212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989d212",
  null
  
)

export default component.exports